import { render, staticRenderFns } from "./JobQueue.vue?vue&type=template&id=31958270&scoped=true"
import script from "./JobQueue.vue?vue&type=script&lang=js"
export * from "./JobQueue.vue?vue&type=script&lang=js"
import style0 from "./JobQueue.vue?vue&type=style&index=0&id=31958270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31958270",
  null
  
)

export default component.exports